export default __webpack_public_path__ + "static/media/img-4.64b8e5eb.png";